import { FC, memo } from 'react';
import { StringUtil } from '@csp/csp-common-util';
import { OnClick } from '../../../common/model/EventModels';
import { LabelWidth } from './model/LabelWidth';
import { ListItemIconAction } from './ListItemIconAction';

type Props = {
  title?: string;
  versionPublishedDate?: string;
  versionPublishedLabel?: string;
  linkText?: string;
  labelWidth?: LabelWidth;
  onClick?: OnClick;
};

export const ListItemStudyDocument: FC<Props> = memo(
  ({ title, versionPublishedDate, versionPublishedLabel, linkText, labelWidth, onClick }) => (
    <ListItemIconAction
      listItemProps={{ alignItems: 'flex-start' }}
      iconProps={{ name: 'document', size: 'xl' }}
      label={title}
      labelProps={{ wordBreak: 'break-all' }}
      subtitle={`${versionPublishedLabel} ${StringUtil.removeSeconds(versionPublishedDate)}`}
      action={linkText}
      actionVariant="link"
      onClick={onClick}
      labelWidth={labelWidth}
    />
  ),
);

ListItemStudyDocument.displayName = 'ListItemStudyDocument';
